import RestApiModel from "@/api/Model/RestApiModel";

class LloydsRiskCode extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-lloyds-risk-codes-ipr';
  }
}

export default LloydsRiskCode;
